import { Platform } from 'react-native';

export const DOMAIN = 'Throbber';
export const USE_NATIVE_DRIVER = Platform.OS !== 'web';
export const DEFAULT_DURATION_MS = 600;
